import React from "react";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
// import Swal from "sweetalert2";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
// import { format } from "date-fns";

class Activities extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      previa: false,
      previa_url: "",
      nivelUsuario: localStorage.nivel_actual,
      working: true,
      modalState: false,
      info_actividad: { evento: {}, documentos: [] },
    };
    this.timeString = this.timeString.bind(this);
    this.formatDate = this.formatDate.bind(this);
    this.handlePrevia = this.handlePrevia.bind(this);
  }

  timeString(hora) {
    if (hora !== undefined) {
      var timeString = hora.split(".")[0].split("-").reverse().join("-");
      var H = +timeString.substr(0, 2);
      var h = H % 12 || 12;
      var ampm = H < 12 || H === 24 ? " AM" : " PM";
      timeString = h + timeString.substr(2, 3) + ampm;
      return timeString;
    }
  }

  formatDate(fecha) {
    if (fecha !== undefined) {
      return fecha.split("-").reverse().join("-").replaceAll("-", "/");
    }
  }

  handlePrevia(e) {
    let doc = e.target.getAttribute("data-file");
    this.setState({ previa: true, previa_url: doc });
  }

  componentDidMount() {
    // si el usuario no es nivel drycip redireccionamos a home
    if (this.state.nivelUsuario !== "3") {
      window.location.href = "/";
    }

    let grid = {
      source: "app/getActividadesLista",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        nombre: {
          label: "Tema",
        },
        tipo_evento: {
          label: "Tipo de evento",
        },
        tipo_sitio: {
          label: "Tipo de sitio",
        },
        lugar: {
          label: "Lugar",
        },
        fecha: {
          label: "Fecha",
          render: (me) => {
            me.innerHTML = this.formatDate(me.data.fecha);
          },
        },
        hora: {
          label: "Hora",
          render: (me) => {
            me.innerHTML = this.timeString(me.data.hora);
          },
        },
      },
      buttons: [
        {
          iconClass: "fa fa-eye",
          btnClass: "btn bg-gradient-blue",
          btnClick: (data) => {
            Api.loading(true);
            Api.fetch("app/getInformacionActividad?id=" + data.id )
              .then((data) => {
                this.setState({ info_actividad: data });
                this.setState({ modalState: true });
              })
              .then(() => {
                Api.loading(false);
                this.setState({ working: false });
              });
          },
          render: (me, data) => {},
        },
      ],
    };

    let mi_grid = Api.grid(grid);

    let busqueda = Api.form({
      target: "#busqueda",
      onchange: (me, data, serial) => {
        //  mi_grid.go(1, serial);
      },
      render: (form) => {
        /** Cargamos el combo de tipo_evento */
        let tipo_evento = Api.loadCatalogue("cat_evento_tipo");
        let option_e = "<option value=0>Seleccione tipo de evento</option>";
        for (let p in tipo_evento) {
          option_e += `<option value="${tipo_evento[p].id}">
                        ${tipo_evento[p].descripcion}
                    </option>`;
        }
        form.querySelector("#tipo_evento").innerHTML = option_e;
        /* Fin de la carga tipo_evento */

        /** Cargamos el combo de tipo sitio */
        let tipo_sitio = Api.loadCatalogue("cat_evento_sitio");
        let option_s = "<option value=0>Seleccione tipo de sitio</option>";
        for (let p in tipo_sitio) {
          option_s += `<option value="${tipo_sitio[p].id}">
                        ${tipo_sitio[p].descripcion}
                    </option>`;
        }
        form.querySelector("#tipo_sitio").innerHTML = option_s;
        /* Fin de la carga sitio */
      },

      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "nombre",
            label: "Tema",
            placeHolder: "Tema de la actividad",
            cols: 6,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "lugar",
            label: "Lugar",
            placeHolder: "Lugar",
            cols: 6,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "tipo_evento",
            label: "Tipo evento",
            placeHolder: "Tipo evento",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "tipo_sitio",
            label: "Tipo sitio",
            placeHolder: "Tipo sitio",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha",
            placeHolder: "Fecha",
            cols: 4,
            value: "",
            autoComplete: "off",
          },
        },
        {
          button: {
            cols: 2,
            name: "buscar",
            label: "",
            text: "Buscar",
            class: "form-control btn-warning ",
            icon: "fas fa-search",
            click: (e) => {
              mi_grid.go(1, busqueda.serial());
            },
          },
        },
      ],
    });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            {/*<Link to="/form/elements">Home</Link>*/}
            Inicio
          </li>
          <li className="breadcrumb-item active">Actividades</li>
        </ol>
        <h1 className="page-header">Actividades</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>
        <div className="hide">
          <fieldset id="cargaDocs"></fieldset>
        </div>
        <Modal
          isOpen={this.state.modalState}
          tabIndex="-1"
          style={{ maxWidth: "100%", width: "85%" }}
        >
          <ModalHeader
            toggle={() => {
              this.setState({ modalState: false });
            }}
          ></ModalHeader>
          <ModalBody>
            <div className={this.state.working ? "" : "hide"}>
              <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                CARGANDO INFORMACIÓN
              </div>
            </div>

            <div className={this.state.working ? "hide" : ""}>
              <div className="row">
                <div className="col-lg-3">
                  <div className="widget100 widget widget-stats bg-gradient-teal m-b-10">
                    <div className="stats-icon stats-icon-lg">
                      <i className="fab fa-lg fa-fw m-r-10 fa-wpforms"></i>
                    </div>
                    <div className="stats-content">
                      <div className="stats-title">Tipo de evento</div>

                      <div className="stats-desc">
                        <h5>{this.state.info_actividad.evento.tipo_evento}</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="widget100 widget widget-stats bg-gradient-yellow m-b-10">
                    <div className="stats-icon stats-icon-lg">
                      <i className="fas fa-lg fa-fw m-r-10 fa-question-circle"></i>
                    </div>
                    <div className="stats-content">
                      <div className="stats-title">Tipo de sitio</div>

                      <div className="stats-desc">
                        <h5>{this.state.info_actividad.evento.tipo_sitio}</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="widget100 widget widget-stats bg-gradient-blue m-b-10">
                    <div className="stats-icon stats-icon-lg">
                      <i className="fas fa-lg fa-fw m-r-10 fa-clock"></i>
                    </div>
                    <div className="stats-content">
                      <div className="stats-title">Fecha</div>

                      <div className="stats-desc">
                        <h5>
                          {this.formatDate(
                            this.state.info_actividad.evento.fecha
                          )}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="widget100 widget widget-stats bg-gradient-green m-b-10">
                    <div className="stats-icon stats-icon-lg">
                      <i className="fas fa-lg fa-fw m-r-10 fa-calendar-alt"></i>
                    </div>
                    <div className="stats-content">
                      <div className="stats-title">Hora</div>

                      <div className="stats-desc">
                        <h5>
                          {this.timeString(
                            this.state.info_actividad.evento.hora
                          )}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <fieldset className="col-md-12">
                <legend>Datos generales</legend>

                <div className="row">
                  <div className="form-group col-md-12">
                    <label>Tema</label>
                    <div className="form-control">
                      {this.state.info_actividad.evento.nombre}
                    </div>
                  </div>

                  <div className="form-group col-md-12">
                    <label>Objetivo</label>
                    <textarea class="form-control" rows="3">
                      {this.state.info_actividad.evento.objetivo}
                    </textarea>
                  </div>

                  <div className="form-group col-md-3">
                    <label>Tipo de evento</label>
                    <div className="form-control">
                      {this.state.info_actividad.evento.tipo_evento}
                    </div>
                  </div>

                  <div className="form-group col-md-3">
                    <label>Tipo de sitio</label>
                    <div className="form-control">
                      {this.state.info_actividad.evento.tipo_sitio}
                    </div>
                  </div>

                  <div className="form-group col-md-3">
                    <label>Participantes hombres</label>
                    <div className="form-control">
                      {this.state.info_actividad.evento.cant_hombres}
                    </div>
                  </div>

                  <div className="form-group col-md-3">
                    <label>Participantes mujeres</label>
                    <div className="form-control">
                      {this.state.info_actividad.evento.cant_mujeres}
                    </div>
                  </div>

                  <div className="form-group col-md-6">
                    <label>Nombre</label>
                    <div className="form-control">
                      {this.state.info_actividad.evento.usuario_participante}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Tipo de participación</label>
                    <div className="form-control">
                      {this.state.info_actividad.evento.tipo_participacion}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Lugar</label>
                    <div className="form-control">
                      {this.state.info_actividad.evento.lugar}
                    </div>
                  </div>

                  <div className="form-group col-md-3">
                    <label>Fecha</label>
                    <div className="form-control">
                      {this.formatDate(this.state.info_actividad.evento.fecha)}
                    </div>
                  </div>

                  <div className="form-group col-md-3">
                    <label>Hora</label>
                    <div className="form-control">
                      {this.timeString(this.state.info_actividad.evento.hora)}
                    </div>
                  </div>
                </div>
              </fieldset>
              <hr />
              <fieldset className="col-md-12">
                <legend>Documentación</legend>
                <div className="table-responsive">
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">Vista previa</th>
                        <th className="text-center">Documento</th>
                        <th className="text-center"></th>
                      </tr>
                    </thead>
                    <tbody className={this.state.working ? "hide" : "show"}>
                      {this.state.info_actividad.documentos.map((ev) => (
                        <tr key={ev.id}>
                          <td className="text-center">
                            <img
                              alt="Vista previa"
                              className="rounded btn"
                              data-file={
                                Api.url + `app/documentoA/?id=${ev.id}`
                              }
                              onClick={this.handlePrevia}
                              width="60"
                              src={
                                Api.url + `app/documentoA/?id=${ev.id}&thumb=1`
                              }
                            />
                          </td>
                          <td className="text-center">Documento soporte</td>
                          <td className="text-center">
                            <div className="btn-group">
                              <a
                                href={
                                  Api.url +
                                  `app/documentoA/?id=${ev.id}&download=1`
                                }
                                className="btn btn-primary"
                              >
                                <i className="fas fa-file-download"></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </fieldset>
            </div>
          </ModalBody>
        </Modal>

        <div className={this.state.previa ? "previa" : "hide"}>
          <iframe
            title="Vista previa"
            className="rounded"
            src={this.state.previa_url}
          ></iframe>
          <center>
            <div className="btn-group">
              <button
                onClick={() => {
                  this.setState({ previa: false });
                }}
                className="btn btn-danger"
              >
                Regresar
              </button>
              <a
                className="btn btn-primary"
                href={this.state.previa_url + "&download=1"}
                download="download"
              >
                Descargar
              </a>
            </div>
          </center>
        </div>
      </div>
    );
  }
}

export default Activities;
